import QueueModalWrapper from "./QueueModalWrapper";
import React, {useEffect, useRef, useState} from "react";
import {useAuth} from "../../../providers/AuthProvider";
import {apiPost, extractPayloadFromResponse} from "../../../services/apiService";
import {useSiteMessage} from "../../../providers/SiteMessageProvider";
import Loading from "../../../components/Loading/Loading";
import imageExtensionIsSafe from "@/utils/imageExtensionIsSafe";

export interface QueueModalPintrestProps {
    setIsOpen: (value: string) => void;
    requestRefresh?: () => void;
}

const uploadImage = async (image: any, authToken: string): Promise<{error?: string; data: any}> => {
    const {url, name, extension, width, height, referringUrl, description} = image || {};

    const response = await apiPost('/q', JSON.stringify({
        type: 'pintrest',
        metadata: {
            url,
            name,
            extension,
            width,
            height,
            referringUrl,
            description
        }
    }), authToken);

    return extractPayloadFromResponse(response);
};

export default function QueueModalPintrest({setIsOpen, requestRefresh}: QueueModalPintrestProps) {
    const [pintrest, setPintrest] = useState<any>(null);

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);

        setPintrest(searchParams.get('pintrest') || '');
    }, []);

    const submitting = useRef<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const {authToken} = useAuth();

    const {setMessage} = useSiteMessage();

    const resetUrl = () => {
        if (pintrest) {
            const params = new URLSearchParams(window.location.search);

            params.delete('pintrest'); // remove a query parameter

            document.location.href = `${window.location.origin}${window.location.pathname}`;
        }
    }

    const onSubmitHandler = (image, callback) => {
        if (!image) {
            setMessage('Missing image');

            return;
        }

        async function postData() {
            try {
                if (!imageExtensionIsSafe(image.url)) {
                    setMessage('File type is not a support image format');

                    return;
                }

                const {error} = await uploadImage(image, authToken);

                if (error) {
                    throw new Error(error);
                }

                setIsOpen('');

                setTimeout(() => {
                    callback && callback();

                    requestRefresh && requestRefresh();
                }, 100);

                setIsLoading(false);
            } catch(error: any) {
                setIsLoading(false);

                setMessage(error.message);
            }
        }

        postData();
    };

    useEffect(() => {
        try {
            if (submitting.current || !pintrest) return;

            submitting.current = true;

            const imageData = decodeURIComponent(pintrest);

            onSubmitHandler(JSON.parse(imageData), resetUrl);
        } catch(error: any) {
            console.log(error);
            setMessage('Something when wrong when trying to import the image from Pintrest');
        }
    },  [submitting.current, pintrest]);

    return (
        <QueueModalWrapper setIsOpen={setIsOpen}>
            <>
                {isLoading && <Loading hasOverlay={true}/>}
                <div className="relative flex flex-col">
                    <h2>Add Pintrest</h2>
                    <p>Uploading now!</p>
                </div>
            </>
        </QueueModalWrapper>
    );
}